// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/js/async/" + ({"354": "lib-axios","535": "lib-router","783": "lib-react",}[chunkId] || chunkId) + "." + {"116": "1446dbc0","122": "21a578a4","242": "578b015f","354": "9c6094ad","489": "425547cc","535": "eea8e3ee","783": "e0609479",}[chunkId] + ".js"
}